import { usePreventScroll } from '@react-aria/overlays';

export function PreventScroll() {
  usePreventScroll();
  return null;
}
